// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Layout'lar
import AdminLayout from './components/layout/AdminLayout';
import UserLayout from './components/layout/UserLayout';

// User Sayfaları
import UserProfilePage from './pages/user/UserProfilePage';
import UserAnnouncementsPage from './pages/user/UserAnnouncementsPage';
import UserNotificationsPage from './pages/user/UserNotificationsPage';
import AppRecommendationsPage from './pages/user/AppRecommendationsPage';
import UserMailPoolPage from './pages/user/UserMailPoolPage';
import UserDashboardPage from './pages/user/UserDashboardPage';

// Admin Sayfaları
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import ManageMembersPage from './pages/admin/ManageMembersPage';
import ManageAppsPage from './pages/admin/ManageAppsPage';
import ManagePaymentsPage from './pages/admin/ManagePaymentsPage';
import ManageMailSettingsPage from './pages/admin/ManageMailSettingsPage';
import ManageAnnouncementsPage from './pages/admin/ManageAnnouncementsPage';
import ManageNotificationsPage from './pages/admin/ManageNotificationsPage';
import AdminActivityPage from './pages/admin/AdminActivityPage'; // <--- YENİ EKLENDİ
import ManageDashboardSettingsPage from './pages/admin/ManageDashboardSettingsPage'; // <--- YENİ EKLENDİ

import LoginPage from './pages/LoginPage';

// --- KORUMALI ROTA BİLEŞENLERİ ---
const AdminRoute = () => {
  const { isAuthenticated, userInfo } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return userInfo.role === 'admin' ? <AdminLayout /> : <Navigate to="/user/dashboard" replace />;
};

const UserRoute = () => {
    const { isAuthenticated, userInfo } = useAuth();
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (userInfo.role === 'user' || userInfo.role === 'admin') {
        return <UserLayout />;
    }
    return <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* === ADMIN ROTALARI === */}
        <Route path="/admin" element={<AdminRoute />}>
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="activity" element={<AdminActivityPage />} /> {/* <--- YENİ ROTA */}
          <Route path="dashboard-settings" element={<ManageDashboardSettingsPage />} /> {/* <--- YENİ ROTA */}
          <Route path="members" element={<ManageMembersPage />} />
          <Route path="apps" element={<ManageAppsPage />} />         
          <Route path="payments" element={<ManagePaymentsPage />} />
          <Route path="mail-settings" element={<ManageMailSettingsPage />} />
          <Route path="announcements" element={<ManageAnnouncementsPage />} />
          <Route path="notifications" element={<ManageNotificationsPage />} />
        </Route>

        {/* === USER ROTALARI === */}
        <Route path="/user" element={<UserRoute />}>
          <Route path="dashboard" element={<UserDashboardPage />} />
          <Route path="profile" element={<UserProfilePage />} />
          <Route path="announcements" element={<UserAnnouncementsPage />} />
          <Route path="notifications" element={<UserNotificationsPage />} />
          <Route path="recommendations" element={<AppRecommendationsPage />} />
          <Route path="mailpool" element={<UserMailPoolPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;